// ---------------------------------------------------------------------------
// Reports the document height to the Wix parent page so the <iframe> can be
// auto-resized (no inner scrollbar). The Wix side listens for a
// "gapco-quote:height" message — see README for the embed snippet.
// ---------------------------------------------------------------------------

import { MESSAGE_TYPES, PARENT_ORIGIN } from "../config";

/**
 * Start observing document height and post it to the parent on every change.
 * Returns a cleanup function. Safe to call when not embedded.
 */
export function startHeightReporter(): () => void {
  const post = () => {
    const height = Math.ceil(
      document.documentElement.getBoundingClientRect().height,
    );
    try {
      window.parent?.postMessage(
        { type: MESSAGE_TYPES.height, height },
        PARENT_ORIGIN,
      );
    } catch {
      /* ignore locked-down parent */
    }
  };

  post();
  const ro = new ResizeObserver(post);
  ro.observe(document.documentElement);
  window.addEventListener("load", post);

  return () => {
    ro.disconnect();
    window.removeEventListener("load", post);
  };
}
